import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Unauthorized from "./components/Unauthorized";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authProvider";
import { BrowserRouter } from "react-router-dom";
import { NotificationProvider } from "./context/NotificationContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

root.render(
  <BrowserRouter>
    <MsalProvider instance={msalInstance}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </MsalProvider>
  </BrowserRouter>,
);
